import { propInit } from "../type";

export const notificationInitSettings: propInit = {
  initApp: true,
  uniqueName: 'notifications',
  path: '/notifications?access_token=$TOKEN$',
  dependencies: [],
  pathEvent: 'meta.type',
}
